import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './zendesk-chat.css';

export class ZendeskChat extends React.PureComponent {
  componentDidMount() {
    this.checkForLoaded();
  }

  componentDidUpdate() {
    this.identify();
  }

  checkForLoaded = () => {
    this.intervalCheck = setInterval(this.handleLoad, 100);
  };

  handleLoad = () => {
    if (!window.zE) return;
    clearInterval(this.intervalCheck);
    this.identify();
  };

  identify = () => {
    if (!window.zE) return;
    window.zE('webWidget', 'identify', {
      name: this.props.user.first_name + ' ' + this.props.user.last_name,
      email: this.props.user.email,
      organization: this.props.location.name,
    });
  };

  render() {
    return null;
  }
}

ZendeskChat.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
    email: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    user: state.employees.user,
    location: state.locations.open,
  };
}

function mapDispatchToProps() {
  return {};
}

function areStatesEqual(prev, next) {
  return (
    prev.employees.user === next.employees.user &&
    prev.locations.open.name === next.locations.open.name
  );
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  areStatesEqual,
})(ZendeskChat);
